import { useCallback, useMemo } from 'react';
// @ts-expect-error Could not find a declaration file for module
import useFilterParams from '../../../hooks/useFilterParams';
import UsageTracker from '../../../utils/UsageTracker';
import ContentCard from '../../../components/TrackCard/ContentCard';
import { getShortContentOverviewUrl, getShortContentUrl, useShort } from '../../shortContent';
import { ShortThumbnailOverlayed } from '..';
import { HasGate } from '../../accounts';
import { useLocation } from 'react-router-dom';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortCard = ({
  shortId,
  playlistId,
  language,
  isFlushOnMobile = true,
  position,
  appearsIn,
  isGhost,
  body,
  thumbnailHeader,
  onClick,
  loadingState,
  use,
  showDescription = true,
  preferPreviewModal,
  renderMenu
}) => {
  const {
    short
  } = useShort(shortId, language);
  const {
    pathname,
    search
  } = useLocation();
  const filterParams = useFilterParams();
  const to = useMemo(() => preferPreviewModal && appearsIn ? getShortContentOverviewUrl({
    shortId,
    language,
    playlistId,
    overviewType: appearsIn,
    pathname,
    search
  }) : getShortContentUrl({
    shortId,
    language,
    playlistId
  }), [appearsIn, language, pathname, playlistId, preferPreviewModal, search, shortId]);
  const onClickHandler = useCallback(() => {
    if (!short) return;
    const {
      name
    } = short;
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'SHORT',
      appearsIn,
      shortId,
      language,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default'
    });
    if (onClick) onClick();
  }, [appearsIn, filterParams, language, onClick, position, short, shortId]);
  if (!short) return loadingState ? /*#__PURE__*/_jsx(_Fragment, {
    children: loadingState
  }) : null;
  const {
    name,
    description
  } = short;
  return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:ShortFormContent",
    children: /*#__PURE__*/_jsx(ContentCard, {
      body: body,
      "data-test-meta": shortId,
      "data-test-type": "short",
      description: showDescription ? description : undefined,
      isFlushOnMobile: isFlushOnMobile,
      isGhost: isGhost,
      name: name,
      onClick: onClickHandler,
      thumbnailOverlayed: /*#__PURE__*/_jsx(ShortThumbnailOverlayed, {
        header: thumbnailHeader,
        isGhost: isGhost,
        language: language,
        renderMenu: renderMenu,
        shortId: shortId
      }),
      to: to,
      use: use
    })
  });
};
export default ShortCard;